import React from "react";
import LinkTreeSection from "../components/sections/Linktree/LinkTree";
import "../Styles/LinkTree.css";
const LinkTreePage = () => {
  return <LinkTreeSection />;
};

export default LinkTreePage;
